import { dateFriendly } from '../helpers/date';
import { numberFormat } from '../helpers/utils';
import { getProductStatusValue } from '../helpers/sku';

/**
 * transform channel
 * @param {Object} channel
 * @returns {Object} channel
 */
export const transformReportChannel = (data = {}) => {
	return {
		id: data.id || '',
		name: data.name || '',
		quantity: data.quantity !== undefined ? numberFormat(data.quantity) : '-',
	};
};

/**
 * transform report list
 * @param {Array} report
 * @returns {Array} report list
 */
export const transformReportChannelList = (data = []) => {
	return data.map((item) => transformReportChannel(item));
};

/**
 * transform report
 * @param {Object} report
 * @returns {Object} report
 */
export const transformReport = (data = {}) => {
	const skuStatus = (() => {
		if (data.is_eol !== undefined && data.is_active !== undefined) {
			return getProductStatusValue(data.is_eol, data.is_active);
		}
		return null;
	})();

	return {
		skuID: data.sku || null,
		productName: data.name || null,
		brand: data.brand || [],
		availableStock: data.stocks?.available ? numberFormat(data.stocks?.available) : null,
		onlineStock: data.stocks?.online ? numberFormat(data.stocks?.online) : null,
		offlineStock: data.stocks?.offline ? numberFormat(data.stocks?.offline) : null,
		totalStock: data.stocks?.total ? numberFormat(data.stocks?.total) : null,
		reserved: data.stock_commitments?.reserved ? numberFormat(data.stock_commitments?.reserved) : null,
		committed: data.stock_commitments?.committed ? numberFormat(data.stock_commitments?.committed) : null,
		channels: data.channel || [],
		channelOrderQty: data.channel_order_qty || {},
		categories: data.categories || null,
		status: skuStatus,
		type: data.type || null,
		eolStatus: data.is_eol || null,
		latestCommittedAt: data.latest_committed_at ? dateFriendly(data.latest_committed_at, 'DD MMM YYYY, HH:mm:ss') : null,
		latestCommittedInDays: data.latest_committed_in_days || null,
	};
};

/**
 * transform report list
 * @param {Array} report
 * @returns {Array} report list
 */
export const transformReportList = (data = []) => {
	return data.map((item) => transformReport(item));
};


/**
 * transform stock report
 * @param {Object} report
 * @returns {Object} stock report
 */
export const transformStockReport = (data = {}) => {
	return {
		availableOnlineStock: data.total_online_available_quantity || null,
		availableOfflineStock: data.total_offline_available_quantity || null,
	};
};
